import {Component, Input} from '@angular/core';
import {LocalDataSource} from "ng2-smart-table";

@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss']
})
export class SearchInputComponent {
  @Input() source: LocalDataSource;
  @Input() placeholder: string;

  onSearch(query: string) {
    if (query === '') {
      this.source.setFilter([]);
    }
    else {
      this.source.setFilter([
        {
          field: 'id',
          search: query,
        },
        {
          field: 'key',
          search: query,
        },
      ], false);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/search-input/search-input.component.ts